<template>
  <div class="main d-flex justify-center align-center flex-column w-100">
    <p class="list__header mx-auto" :class="mdAndDown ? 'mx-auto' : 'ml-0 mr-auto'">
      Canales de referencia (porcentaje)
    </p>

    <p class="params-summary">
      <template v-if="sectionName"><b>Sección:</b> {{ sectionName }} · </template>
      Entre {{ startLabel }} y {{ endLabel }}
    </p>

    <ApexChart
      ref="donutRef"
      type="donut"
      :width="width"
      :height="height"
      :options="options"
      :series="series"
      class="mx-auto"
    />
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ReferencesChannelsDonut',
  props: {
    globalCategories: { type: Array, default: () => [] },
    globalSections:   { type: Array, default: () => [] },
    globalCategory:  { type: String, default: null },
    globalSection:   { type: [Number, String], default: null },
    globalStartDate: { type: String, default: null },
    globalEndDate:   { type: String, default: null },
    sectionName:     { type: String, default: '' },
    width:           { type: [String, Number], default: '420' },
    height:          { type: [String, Number], default: '400' },
    includeInactive: { type: Boolean, default: false },
  },
  data () {
    return {
      series: [],
      options: {
        labels: [],
        chart: { type: 'donut' },
        legend: {
          position: 'bottom',
          formatter: (seriesName, opts) => {
            const val = opts.w.globals.series[opts.seriesIndex] || 0
            const total = opts.w.globals.seriesTotals.reduce((a,b)=>a+b,0) || 1
            const pct = (val * 100 / total).toFixed(1)
            return `${seriesName} — ${val} (${pct}%)`
          }
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => `${val.toFixed(1)}%`
        },
        tooltip: {
          y: {
            formatter: (value, { seriesIndex, w }) => {
              const label = w.config.labels[seriesIndex] || ''
              const total = w.globals.seriesTotals.reduce((a,b)=>a+b,0) || 1
              const pct = (value * 100 / total).toFixed(1)
              return `${label}: ${value} (${pct}%)`
            }
          }
        },
        colors: ['#1E88E5', '#00ACF3', '#00C9DF', '#00E1B5', '#93F188', '#F9F871', '#8B5CF6', '#F59E0B'],
        plotOptions: {
          pie: { donut: { size: '65%' } }
        }
      }
    }
  },
  computed: {
    mdAndDown () { return this.$vuetify.breakpoint.mdAndDown },
    startLabel () { return this.formatDate(this.globalStartDate) },
    endLabel   () { return this.formatDate(this.globalEndDate) },
  },
  watch: {
    globalCategories () { this.reload() },
    globalSections   () { this.reload() },
    globalCategory() { this.reload() },
    globalSection()   { this.reload() },
    globalStartDate() { this.reload() },
    globalEndDate()   { this.reload() },
    includeInactive() { this.reload() },
  },
  methods: {
    formatDate (v) {
      if (!v) return '—'
      const d = new Date(v)
      if (Number.isNaN(d.getTime())) return '—'
      const dd = String(d.getDate()).padStart(2, '0')
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const yyyy = d.getFullYear()
      return `${dd}/${mm}/${yyyy}`
    },
    buildParams () {
      const p = new URLSearchParams()
      if (this.globalStartDate) p.set('fecha_inicio', this.globalStartDate)
      if (this.globalEndDate)   p.set('fecha_fin',    this.globalEndDate)
      if (this.includeInactive) p.set('include_inactive', '1')
      const secs = (Array.isArray(this.globalSections) && this.globalSections.length)
        ? this.globalSections
        : (this.globalSection ? [this.globalSection] : [])
      const cats = (Array.isArray(this.globalCategories) && this.globalCategories.length)
        ? this.globalCategories
        : (this.globalCategory ? [this.globalCategory] : [])
      if (secs.length) {
        secs.filter(Boolean).forEach(id => p.append('seccion', id))
      } else if (cats.length) {
        cats.filter(Boolean).forEach(slug => p.append('categoria', slug))
      }
      return p
    },
    async fetchData () {
      const { data } = await axios.get(`api/admin/graficas/referidos_resumen/?${this.buildParams().toString()}`)
      return data
    },
    async reload () {
      try {
        const data = await this.fetchData()
        const labels = data.map(d => d.nombre)
        const series = data.map(d => Number(d.cantidad || 0))

        const allZero = series.every(v => v === 0)
        this.options = {
          ...this.options,
          labels: allZero ? ['Sin datos'] : labels
        }
        this.series = allZero ? [1] : series

        this.$refs.donutRef?.refresh && this.$refs.donutRef.refresh()
      } catch (e) {
        console.error('Error cargando donut de canales', e)
        this.options = { ...this.options, labels: ['Sin datos'] }
        this.series = [1]
        this.$refs.donutRef?.refresh && this.$refs.donutRef.refresh()
      }
    },
    clearFiltersAndReload () {
      this.reload()
    }
  },
  mounted () { this.reload() }
}
</script>

<style lang="scss" scoped>
.main {
  background-color: #fff;
  padding: 20px;
  border-radius: 15px;
}
.list {
  &__header {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #455A64;
  }
}
.params-summary {
  font-size: 13px;
  color: #455A64;
  margin: 6px 0 12px;
}
</style>